
import formatApi from "@/services/api/Formatting"
import { CaseDetails } from "@/types"
import { Format } from "@/types/format"
import moment from "moment"
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import vSelect from "vue-select"
import { Getter } from "vuex-class"
	@Component({
		components: {
			"v-select": vSelect
		}
	})
export default class DownloadTemplateSelect extends Vue {
		@Getter("getCaseName") getCaseName!: string;
		@Getter("getRecordName") getRecordName!: string;

		@Prop({ required: true })
		private currentCase!: CaseDetails;

		@Prop({ required: true, default: false })
		private value!: boolean;

		private formatTemplates: Format[] = [];
		private selectedFormat: Format | null = null;

		private get PDFTitle (): string {
			const currentDate = moment().format("YYYY-MM-DD")
			const caseName = this.currentCase.isCase ? this.getCaseName : this.getRecordName
			return `${caseName}-${this.currentCase.caseNumber} - ${this.selectedFormat?.title} - ${currentDate}`
		}

		private get isModalOpen (): boolean {
			return this.value
		}

		private set isModalOpen (value: boolean) {
			this.$emit("input", value)
		}

		public open (): void {
			this.$bvModal.show("downloadPdfTemplateModal")
		}

		private async mounted (): Promise<void> {
			await this.getFormatTemplates()
		}

		// Dropdown logic

		private async getFormatTemplates (): Promise<void> {
			const formats = await formatApi.formatGet()
			this.formatTemplates = formats.filter(f => f.templateId === this.currentCase.templateId)
		}

		// Download Buttons

		private get downloadButtonEnabled () : boolean {
			return this.selectedFormat != null
		}

		private get downloadButtonTooltip (): string {
			return this.downloadButtonEnabled ? "Download PDF" : "Please Select Download Template"
		}

		private async onDownloadClick () : Promise<void> {
			if (this.downloadButtonEnabled) {
				await formatApi.downloadPdf(this.PDFTitle, this.currentCase.caseNumber!, this.selectedFormat!)
				this.$bvModal.hide("downloadPdfTemplateModal")
			}
		}
}
